import React from 'react';

const Footer = () => {
  return (
    <footer className="py-6 text-center text-sm text-gray-600">
      Made by{' '}
      <a 
        href="https://www.linkedin.com/in/jeanbaptistealarcon/" 
        target="_blank" 
        rel="noopener noreferrer"
        className="text-indigo-600 hover:text-indigo-800"
      >
        jean-baptiste
      </a>
      . Leave{' '}
      <a 
        href="https://buy.stripe.com/6oE17Hb5haLB4RqeUU" 
        target="_blank" 
        rel="noopener noreferrer"
        className="text-indigo-600 hover:text-indigo-800"
      >
        a tip
      </a>
      {' '}to help keep the tool running :)
    </footer>
  );
};

export default Footer; 